import React, { useEffect, useState } from 'react'
import Header from '../../components/Header'
import SearchInput from '../../components/SearchInput'
import { authAxios } from '../../helpers/axios'
import { toast } from 'react-toastify'
import FilterSelect from '../../components/FilterSelect'
import { useNavigate, useLocation, Link } from 'react-router-dom'
import ManageOrder from './components/ManageOrder'
import { ErrorToast, InfoToast } from '../../helpers/toasters'
import ViewOrder from './components/ViewOrder'
import { LIMIT } from '../../helpers/constants'
import RightIcon from '../../images/right.svg'
import SortIcon from '../../images/sort.svg'
import FilterIcon from '../../images/filter.svg'
import RupeeIcon from '../../images/rupee.svg'
import FilterActiveIcon from '../../images/filteractive.svg'
import FilterOrder from './components/FilterOrder'
import Toast from 'react-toastify'
import { getDateFormat, getTimeFormat, renderWeight } from '../../helpers/utils'
import CreatePurchaseOrder from './components/CreatePurchaseOrder'
import CreateCommonBomPurchase from './components/CreateCommonBomPurchase'

export default function Purchase() {

    const [searchText,setSearchText] = useState('')
    const [orders,setOrders] = useState([])
    const [showManage,setShowManage] = useState({status:false,edit:null,type:null})
    const [sort,setSort] = useState('status')
    const [exporting,setExporting] = useState(false)

    const navigate = useNavigate()
    const location = useLocation()
    const [offset,setOffset] = useState(0);
    const [count,setCount] = useState(5)
    const [filters,setFilters] = useState({status:null,startDate:null,endDate:null})
    const [showFilters,setShowFilters] = useState(false)
    const [submitting,setSubmitting] = useState(false)
    


    async function exportOrders(){

        try 
        {
            setExporting(true)
            let query = `limit=${LIMIT}&offset=${offset}&search=${searchText}&populate=true&sort=${sort}`;
            if(filters.buyerId) query+=`&buyerId=${filters.buyerId.id}`
            if(filters.status) query+=`&status=${filters.status}`
            if(filters.startDate) query+=`&startDate=${`${new Date(filters.startDate).getDate()}-${new Date(filters.startDate).getMonth()+1}-${new Date(filters.startDate).getFullYear()}`}`
            if(filters.endDate) query+=`&endDate=${`${new Date(filters.endDate).getDate()}-${new Date(filters.endDate).getMonth()+1}-${new Date(filters.endDate).getFullYear()}`}`
            let response = await authAxios.get(`${process.env.REACT_APP_BASE_URL}/orders/export?${query}`,{responseType:'blob'})
            const url = window.URL.createObjectURL(new Blob([response.data]));

            // Create a link element
            const link = document.createElement('a');
            link.href = url;

            // Set the filename for the downloaded file
            link.setAttribute('download', 'retailers_export.xlsx');

            // Append the link to the body
            document.body.appendChild(link);

            // Trigger the download
            link.click();

            // Cleanup
            link.parentNode.removeChild(link);
            setExporting(false)
        } catch (error) {
            setExporting(false)
            console.log(error)
            toast('Error getting orders')
        }
    } 

    const RightContent = ()=>
    {
        return <div>
            {/* <button type='button' disabled={exporting} className='btn-md mr-4' onClick={()=>exportOrders()}>{exporting ? 'Exporting...' : 'Export'}</button> */}
          <button type='button' className='btn-md font-semibold tracking-normal mr-4' onClick={()=>setShowManage({status:true,edit:null,type:'commonBom'})}>Create Common BOM Purchase Order</button>
          <button type='button' className='btn-md font-semibold tracking-normal' onClick={()=>setShowManage({status:true,edit:null,type:'unique'})}>Create Purchase Order</button>
        </div>
    }

    async function getOrders(filters,sort,offset,searchText){

        try 
        {
            console.log('filters',filters)
            let query = `limit=${LIMIT}&offset=${offset}&populate=true&sort=${sort}`;
            if(searchText) query+=`&search=${searchText}`
            if(filters.status ) query+=`&status=${filters.status}`
            if(filters.startDate) query+=`&startDate=${`${new Date(filters.startDate).getDate()}-${new Date(filters.startDate).getMonth()+1}-${new Date(filters.startDate).getFullYear()}`}`
            if(filters.endDate) query+=`&endDate=${`${new Date(filters.endDate).getDate()}-${new Date(filters.endDate).getMonth()+1}-${new Date(filters.endDate).getFullYear()}`}`
            let res = await authAxios.get(`${process.env.REACT_APP_BASE_URL}/purchase?${query}`)
            setOrders(res.data.orders)
            setCount(res.data.totalCount)
        } catch (error) {
            console.log(error)
            toast('Error getting orders')
        }
    } 


    const onFilterSubmit = (filters)=>
    {
        try 
        {
            setFilters({...filters})
            setCount(5)
            setOffset(0)
            setShowFilters(false)
            const params = new URLSearchParams();
            Object.keys(filters).forEach(key => {
                if (filters[key]) {
                    params.set(key, filters[key]);
                } else {
                    params.delete(key);
                }
            });
            if(searchText) params.set('search',searchText)
            navigate(`?${params.toString()}`);
            getOrders(filters,sort,offset,searchText)
        } catch (error) {
            toast('Order Filtered')
        }
    }

    const clearFilter = ()=>
    {
        try 
        {
            setFilters({routeId:null,cityId:null,status:null,distributorId:null,retailerId:null,teamId:null,salesRepId:null,startDate:null,endDate:null})
            setShowFilters(false)
            const queryParams = new URLSearchParams({
                offset: 0,
                search: searchText,
                sort: sort
            }).toString();
            navigate(`?${queryParams}`);
        } catch (error) {
            toast('Order Filtered')
        }
    }
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const search = params.get('search') || '';
        const sort = params.get('sort') || 'status';
        const offset = parseInt(params.get('offset')) || 0;
        const filters = {
            status: params.get('status') || null,
            startDate: params.get('startDate') || null,
            endDate: params.get('endDate') || null,
        };

        setSearchText(search);
        setSort(sort);
        setOffset(offset);
        setFilters(filters);

        if (search !== '' || Object.values(filters).some(value => value !== null)) {
            getOrders(filters,sort,offset,search);
        }
    }, [location.search]);

    useEffect(()=>
    {
        getOrders(filters,sort,offset,searchText);
    },[offset,searchText,filters,sort])


    const onOrderCreate = async(manageData)=>
    {
        try 
        {
            // e.preventDefault()
            setSubmitting(true)
            let orderProducts=[];

            let res = await authAxios.post(`${process.env.REACT_APP_BASE_URL}/purchase`,{...manageData})  
            getOrders(filters,sort,offset,searchText)
            setShowManage({status:false,edit:null,type:null})
            setSubmitting(false)
            InfoToast('Order Created')
        } catch (error) {
            setSubmitting(false)
            ErrorToast(error?.response?.data?.name || 'Error creating order')
            
        }
    }
  
    const onCommonBomOrderCreate = async(e,manageData)=>
    {
        e.preventDefault()
        try 
        {
            // e.preventDefault()
            setSubmitting(true)
            let orderProducts=[];
            // manageData.purchaseProducts.map((item,index)=>
            // {
            //     if(item && ((item.quantity && item.quantity > 0) || (item.product)) ) return orderProducts.push({productId:item.productId,quantity:item.quantity})
            // })
            let res = await authAxios.post(`${process.env.REACT_APP_BASE_URL}/purchase/common-bom`,{...manageData})  
            getOrders(filters,sort,offset,searchText)
            setShowManage({status:false,edit:null,type:null})
            setSubmitting(false)
            InfoToast('Order Created')
        } catch (error) {
            setSubmitting(false)
            ErrorToast(error?.response?.data?.error || 'Error creating Commond BOM order')
            
        }
    }

    const onSortPress = (type)=>
    {
        if (sort === type) {
            if(sort === `-${type}`) setSort(type)
            else setSort(`-${type}`);
          } else {
            setSort(type);
          }
    }
    
    const onSearchChange = (value) => {
        setSearchText(value);
        const params = new URLSearchParams(location.search);
        params.set('search', value);
        navigate({ search: params.toString() });
    }


  return (
    <>
        <Header title={'Purchase Order Management'} RightContent={RightContent}/>
        <div className=' flex justify-between items-stretch border-b border-[#e3e3e3] bg-white'>
            <div className='flex'>
                <SearchInput value={searchText} setValue={onSearchChange} placeholder={'Search order'} label={'Search order'} />
                <div className='flex w-full border-r items-center h-full justify-center text-center'>
                    <div
                        className='px-2 hover:bg-[#f6f6f6] h-full cursor-pointer flex items-center flex-1 justify-center'
                        onClick={() => {
                        if (offset > 0) {
                            setOffset(offset - LIMIT);
                        }
                        }}
                    >
                        <img src={RightIcon} className='w-[20px] h-[20px] rotate-180' alt='Previous Page' />
                    </div>
                    <p className='text-xs whitespace-nowrap w-[80px] justify-center'>{offset + 1}-{Math.min(offset + LIMIT, count)} of {count}</p>
                    <div
                        className='px-2 hover:bg-[#f6f6f6] h-full cursor-pointer flex items-center flex-1 justify-center'
                        onClick={() => {
                        if (offset + LIMIT < count) {
                            setOffset(offset + LIMIT);
                        }
                        }}
                    >
                        <img src={RightIcon} className='w-[20px] h-[20px]' alt='Next Page' />
                    </div>
                    </div>
            </div>
            <div className='flex justify-end h-[100%] self-stretch items-center px-4 border-l border-[#e3e3e3] hover:bg-[#f6f6f6] cursor-pointer' onClick={()=>setShowFilters(true)}>
            {(filters.cityId || filters.routeId || filters.distributorId || filters.retailerId || filters.teamId || filters.salesRepId || filters.startDate || filters.endDate) ? <img src={FilterActiveIcon} className={`w-[24px] h-[24px]`} alt='Filter' /> : <img src={FilterIcon} className={`w-[24px] h-[24px]`} alt='Filter' /> }
            </div>
        </div>
        <div className='bg-white w-full flex-1 flex overflow-scroll'>
            <table className=' table-auto w-full flex-1 '>
                <thead className='bg-[#f9f9f9] w-full'>
                    <tr className='w-full'>
                
                    <td><p onClick={()=>onSortPress('orderId')} className='cursor-pointer flex items-center hover:text-black'>Order ID {sort === 'orderId' || sort === '-orderId'? sort.charAt(0)==='-' ? <img src={SortIcon} className='rotate-[180deg] h-[16px] w-[16px] ml-1'/> : <img src={SortIcon} className='h-[16px] w-[16px] ml-1'/> : null}</p></td>
                   
                    <td><p onClick={()=>onSortPress('orderId')} className='cursor-pointer flex items-center hover:text-black'>Sales Order ID/Buyer  {sort === 'orderId' || sort === '-orderId'? sort.charAt(0)==='-' ? <img src={SortIcon} className='rotate-[180deg] h-[16px] w-[16px] ml-1'/> : <img src={SortIcon} className='h-[16px] w-[16px] ml-1'/> : null}</p></td>

                    <td><p onClick={()=>onSortPress('totalMaterials')} className='cursor-pointer flex items-center hover:text-black'>Total Materials {sort === 'totalMaterials' || sort === '-totalMaterials'? sort.charAt(0)==='-' ? <img src={SortIcon} className='rotate-[180deg] h-[16px] w-[16px] ml-1'/> : <img src={SortIcon} className='h-[16px] w-[16px] ml-1'/> : null}</p></td>
                    
                    <td><p onClick={()=>onSortPress('receivedMaterials')} className='cursor-pointer flex items-center hover:text-black'>Received Materials {sort === 'receivedMaterials' || sort === '-receivedMaterials'? sort.charAt(0)==='-' ? <img src={SortIcon} className='rotate-[180deg] h-[16px] w-[16px] ml-1'/> : <img src={SortIcon} className='h-[16px] w-[16px] ml-1'/> : null}</p></td>

                    <td><p onClick={()=>onSortPress('createdAt')} className='cursor-pointer flex items-center hover:text-black'>Ordered/Delivery On {sort === 'createdAt' || sort === '-createdAt'? sort.charAt(0)==='-' ? <img src={SortIcon} className='rotate-[180deg] h-[16px] w-[16px] ml-1'/> : <img src={SortIcon} className='h-[16px] w-[16px] ml-1'/> : null}</p></td>

                    <td><p onClick={()=>onSortPress('status')} className='cursor-pointer flex items-center hover:text-black'>Status {sort === 'status' || sort === '-status'? sort.charAt(0)==='-' ? <img src={SortIcon} className='rotate-[180deg] h-[16px] w-[16px] ml-1'/> : <img src={SortIcon} className='h-[16px] w-[16px] ml-1'/> : null}</p></td>
                    {/* <td><p onClick={()=>onSortPress('status')} className='cursor-pointer flex items-center hover:text-black'>Status {sort === 'status' || sort === '-status'? sort.charAt(0)==='-' ? <img src={SortIcon} className='rotate-[180deg] h-[16px] w-[16px] ml-1'/> : <img src={SortIcon} className='h-[16px] w-[16px] ml-1'/> : null}</p></td> */}
                    {/* <td><p>Action</p></td> */}
                    </tr>
                </thead>
                <tbody>
                    {
                        orders.map((item,index)=>
                        {
                            // onClick={()=>navigate(`/sales/${item.id}`)}
                            return <Link to={`/purchase/${item.id}`} key={index}>
                                    <tr>
                                    <td className='capitalize w-full'>
                                        <div>
                                            <p className='text-sm font-regular my-0'>#{item.orderId}</p>
                                        </div>
                                </td>
                                    <td className='capitalize w-full'>
                                        <div>
                                            <p className='text-sm font-regular my-0'>{item.salesOrder?.orderId ? `#${item.salesOrder?.orderId}` : 'Not Available'}</p>
                                            <p className='text-xs text-[#959595] font-regular my-0'>{item.salesOrder?.buyer?.name}</p>
                                        </div>
                                </td>
                                <td className='capitalize'>
                                <div>
                                        <p className='text-sm font-regular my-0'>{item.totalMaterials}</p>
                                    </div>
                                </td>
                                <td className='capitalize'>
                                <div>
                                        <p className='text-sm font-regular my-0'>{item.receivedMaterials}</p>
                                    </div>
                                </td>
                                <td className='capitalize'>
                                    <div>
                                        <p className='text-sm font-regular my-0'>{getDateFormat(item.orderDate)}</p>
                                        <p className='text-sm font-regular my-0'>{item.expectedDeliveryDate ? getDateFormat(item.expectedDeliveryDate) : null}</p>
                                    </div>
                                </td>

                                <td className='capitalize'>
                                <div>
                                        <p className={`text-[13px] font-regular px-3 inline-block py-1 rounded-md ${item.status ===  'created' ? 'text-[#454545] bg-gray-200 ' : item.status === 'partial' ? 'text-orange-600 bg-orange-100 ' : 'bg-[#39C7A5] bg-opacity-30 text-green-700 '}}`}>{item.status}</p>
                                    </div>
                                </td>
                                </tr>
                            </Link>
                        })
                    }
                </tbody>
            </table>
        </div>
        {/* <div className=' flex justify-between items-stretch border-t border-[#e3e3e3] bg-white w-full'>
            <div className='flex px-6 py-2 justify-between w-full'>
                <p className='text-[13px] text-gray-600 font-medium my-0'>Orders(Total/Cancelled/Pending) - {summary.totalOrders}/{summary.cancelledOrders}/{summary.pendingOrders}</p>
                <p className='text-[13px] text-gray-600 font-medium my-0'>Total Points - {summary.totalPoints}</p>
                <p className='text-[13px] text-gray-600 font-medium my-0'>Total Weight - {(summary.totalWeight/1000).toFixed(2)}Kgs</p>
                <p className='text-[13px] text-gray-600 font-medium my-0'>Total Amount - {summary.totalAmount}</p>
                <p className='text-[13px] text-gray-600 font-medium my-0'>Total Qty - {summary.totalQty}</p>
            </div>
        </div> */}
        { showManage.status && showManage.type === 'unique' ? <CreatePurchaseOrder submitting={submitting} onClose={setShowManage} edit={showManage.edit} onSubmit={onOrderCreate}/> : null}
        { showManage.status && showManage.type === 'commonBom' ? <CreateCommonBomPurchase submitting={submitting} onClose={setShowManage} edit={showManage.edit} onSubmit={onCommonBomOrderCreate}/> : null}
        { showFilters ? <FilterOrder onSubmit={onFilterSubmit}  filters={filters} onClose={setShowFilters} clearFilter={clearFilter}/> : null}
    </>
  )
}